export var version = '3.7.9';
//# sourceMappingURL=version.js.map